import type { Static } from 'runtypes';
import { Array, Number, Record, String } from 'runtypes';

type Resolutions = 'day' | 'week' | 'month';
type Groupings = 'none' | 'organization' | 'email';

const GroupRuntype = Record({
  name: String,
  pageViews: Array(Number),
  sessions: Array(Number),
  users: Array(Number),
  crashes: Array(Number),
  duration: Array(Number),
});

const ExecutiveReportRuntype = Record({
  bucketLabels: Array(String),
  groups: Array(GroupRuntype),
});

type ExecutiveReportType = Static<typeof ExecutiveReportRuntype>;

export { ExecutiveReportRuntype };
export type { ExecutiveReportType, Resolutions, Groupings };
